class UrlsService {
    public login(): string {
        return "/login";
    }

    public app(): string {
        return "/";
    }

    public reporting(): string {
        return "/reporting";
    }

    public dashboard(): string {
        return "/dashboard";
    }

    public projection(): string {
        return "/projection";
    }
}

const urlService = new UrlsService();

export { urlService };